var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarehouseCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.48 23.472c.273 1.43 1.635 2.383 3.133 2.111l11.847-2.315c1.566-.272 2.383-1.634 2.11-3.132L31.255 7.881c-.34-1.566-1.702-2.383-3.131-2.11L16.209 8.016c-1.498.204-2.451 1.838-2.111 3.132l2.383 12.323zM28.26 7.54l-4.63 6.877-6.877-4.63L28.26 7.54zm-8.783 16.205l4.63-6.877 6.876 4.698-11.506 2.179zm5.65-8.375l4.494-6.672 2.18 11.166-6.673-4.494zm-2.518.545l-4.494 6.672-2.179-11.166 6.673 4.494z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.136 26.4c-.068-.477-.544-.817-1.021-.68L16.82 28.986c-.749-1.906-2.655-3.268-4.834-3.268h-.068L8.243 4.75C8.174 4.272 7.766 4 7.357 4H3.885A.901.901 0 003 4.885c0 .477.409.885.885.885h2.792l3.472 20.221c-1.975.681-3.404 2.656-3.404 4.835A5.172 5.172 0 0011.919 36a5.172 5.172 0 005.175-5.174v-.069l17.293-3.268c.545-.136.885-.612.75-1.089zm-23.08 7.83c-1.839 0-3.405-1.498-3.405-3.404a3.371 3.371 0 013.404-3.405 3.371 3.371 0 013.405 3.405c0 1.906-1.566 3.404-3.405 3.404z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouseCart);
export default __webpack_public_path__ + "static/media/warehouse-cart.b2b8f890.svg";
export { ForwardRef as ReactComponent };